import { ModuleIOValueTypeEnum, ModuleTemplateTypeEnum } from '../../constants';
import { FlowNodeInputTypeEnum, FlowNodeTypeEnum } from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

export const DelayModule: FlowModuleTemplateType = {
  id: 'DelayModule',
  templateType: ModuleTemplateTypeEnum.flowControl,
  flowType: FlowNodeTypeEnum.delay,
  name: '时间控制',
  description: '在指定时间后，开始执行后续流程',
  inputs: [
    Input_Template_Switch,
    {
      label: '对象id',
      key: 'delayObjectId',
      required: true,
      type: FlowNodeInputTypeEnum.hidden,
      valueType: ModuleIOValueTypeEnum.string,
      showTargetInApp: true,
      showTargetInPlugin: true,
      value: '{chatId}',
    },
    {
      label: '延迟时间',
      valueType: ModuleIOValueTypeEnum.number,
      type: FlowNodeInputTypeEnum.numberInput,
      key: 'delaySeconds',
      value: 0,
      required: true,
      showTargetInApp: false,
      showTargetInPlugin: false,
      min: 0,
    },
  ],
  outputs: [Output_Template_Finish],
};
